<template>
  <div class="container">

    <div class="container" id="homeFirst" v-if="$store.state.isPc">
      <img :src="homeImg" class="content"/>
      <div class="title">
        <div>TIME</div>
        <div>WILL TELL.</div>
        <!--        <div class="subtitle">重建你的时间秩序</div>-->
      </div>
      <img src="../../../assets/images/icon_home_frisst_title.svg"
           style="width: 240px;height: 29px;margin-top: 20px;margin-left: 7.71vw;"/>
      <div class="slogan">
        <div>趁早·创建正向生活</div>
        <div>提供时间管理及目标达成解决方案</div>
      </div>
      <div class="bottom flexVC2">
        <div>向下滑动</div>
        <div class="pR " style="height: 40px;margin-top: 10px;">
          <div class="point"></div>
          <div class="homeLine"></div>
        </div>
      </div>
    </div>
    <div class="container-m pR" v-if="!$store.state.isPc">
      <div class="title-m">
        <div>TIME</div>
        <div>WILL TELL.</div>
      </div>
      <img :src="homeImgMobile" class="w100m" style="margin-top: 0.8rem;"/>
      <div class="slogan-m">
        <div>趁早·创建正向生活</div>
        <div>提供时间管理及目标达成解决方案</div>
      </div>
      <div class="bottom flexVC2">
        <div style="font-size: 0.22rem;">向上滑动</div>
        <div class="pR " style="height: 40px;margin-top: 10px;">
          <div class="point"></div>
          <div class="homeLine"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import homeImg from '@/assets/images/icon_home_frist_content.png'
  export default {
    name: "homeFirst",
    data() {
      return {
        homeImg: homeImg,
        homeImgMobile: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mobile/icon_home_1.png',
      }
    },
    methods:{
      test1(e){
        console.log('上滑',e)
      },
      test2(e){
        console.log('下滑')
      }
    }
  }
</script>

<style scoped>

  #homeFirst {
    background-image: url("../../../assets/images/bg_home_frist.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
  }

  .title {
    font-size: 100px;
    font-family: SFUIDisplay-Heavy, SFUIDisplay;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    line-height: 100px;
    padding-top: 16.67vh;
    margin-left: 7.71vw;
    z-index: 1000;
    display: block;
  }

  .subtitle {
    font-size: 24px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
  }

  .slogan {
    font-size: 15px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    position: absolute;
    left: 7.71vw;
    bottom: 9.07vh;
    z-index: 1000;
  }

  .content {
    width: 70vw;
    height: auto;
    min-width: 729px;
    min-height: 370px;
    position: absolute;
    right: 0;
    bottom: 9.07vh;
    z-index: 10;
  }

  .bottom {
    width: 100%;
    height: auto;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .homeLine {
    width: 1px;
    height: 40px;
    background: #000000;
  }

  .point {
    width: 8px;
    height: 8px;
    background: #D70050;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: -4px;
    /*transform: translate(-50%, 0);*/
    -webkit-animation: spin 2s linear alternate infinite; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 2s linear alternate infinite;
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateY(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateY(40px);
    }
  }

  @keyframes spin {
    from {
      transform: translateY(40px);
    }
    to {
      transform: translateY(0px);
    }
  }

  @keyframes spin2 {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(40px);
    }
  }


  @media screen and (max-width: 1440px){
    .content {
      width: 60vw;
      height: auto;
      min-width: 729px;
      min-height: 370px;
      position: absolute;
      right: 0;
      bottom: 12.07vh;
      z-index: 10;
    }

    .slogan {
      font-size: 15px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      position: absolute;
      left: 7.71vw;
      bottom: 12.07vh;
      z-index: 1000;
    }
  }


  @media screen and (max-width: 1440px) {

    .title {
      font-size: 70px;
      font-family: SFUIDisplay-Heavy, SFUIDisplay;
      font-weight: 800;
      color: rgba(0, 0, 0, 0.85);
      line-height: 100px;
      padding-top: 16.67vh;
      margin-left: 7.71vw;
      z-index: 1000;
      display: block;
    }
  }

/**********************************  移动端********************************************/

  .title-m {
    font-size: 0.72rem;
    font-family: SFUIDisplay-Heavy, SFUIDisplay;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.72rem;
    padding-top: 16.67vh;
    margin-left: 6.4vw;
    z-index: 1000;
    display: block;
  }

  .slogan-m{
    width: 100%;
    text-align: center;
    font-size: 0.26rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.8rem;
  }


/*  *************************************************************************************/

</style>



// WEBPACK FOOTER //
// src/page/home/components/homeFirst.vue